import { COOKIE_MORTGAGE_SEARCH } from '@/constants/cookies';
import { getMortgage, getMortgageSearch } from '@/graphql/queries/banking/mortgage';
import lang from '@/lang/middleware/products/mortgage';

export default async ({ app, $apolloQuery, $cookies, redirect, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const code = $cookies.get(COOKIE_MORTGAGE_SEARCH);
  const resetSearch = () => store.commit('search/reset', { type: 'mortgage' });
  let searchCode;

  if (code) {
    await $apolloQuery(getMortgageSearch, { code }).then(search => {
      store.commit('search/set', search);
      searchCode = search.code;
    }).catch(_ => resetSearch());
  } else {
    resetSearch();
  }
  await $apolloQuery(getMortgage, { code: route.params.code, searchCode }).then(mortgage => {
    if (mortgage.slug !== route.params.slug) {
      return redirect(301, app.localePath(`/compare-mortgages/${mortgage.institution.slug}/${mortgage.code}/${mortgage.slug}/`));
    }
    const description = store.$i18n.t('show.description');
    const title = `${mortgage.institution.name} ${mortgage.name}`;
    const jumbo = { title, type: 'generic' };
    const search = store.getters['search/get'];
    if (search.code) {
      const opts = {
        amount: store.$i18n.n(search.amount, 'currencyRound'),
        ltv: store.$i18n.n(search.ltv / 100, 'percent'),
        term: store.$i18n.tc('year', search.term)
      };
      jumbo.list = ['amount', 'ltv', 'term'].map(key => store.$i18n.t(`show.list.${key}`, opts));
    }
    store.commit('jumbotron/SET_JUMBOTRON', jumbo);
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'], ['i18n/banking', '/money/'],
      ['i18n/mortgages', '/compare-mortgages/'],
      ['i18n/mortgage-lenders', '/compare-mortgages/lenders/'],
      [mortgage.institution.name, `/compare-mortgages/${mortgage.institution.slug}`, 'mobile'],
      mortgage.name
    ]);
    store.commit('pageContent/setHead', { description, title });
    store.commit('products/set', mortgage);
  });
};
